import {
  physicalStockKeys,
  productKeys,
  settlementCreditKeys,
} from "@fero/hooks";
import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateSaleQueries = () => {
  const queryClient = useQueryClient();

  const invalidateAllQueries = () => {
    queryClient.invalidateQueries({ queryKey: productKeys.all });
    queryClient.invalidateQueries({ queryKey: settlementCreditKeys.all });
    queryClient.invalidateQueries({ queryKey: physicalStockKeys.all });
  };

  return { invalidateAllQueries };
};
